// Swiper is loaded globally via script tag in scripts.liquid
// Define a web component for the carousel
class ContentCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.swiper');
    this.nextArrow = this.querySelector('.swiper-button-next');
    this.prevArrow = this.querySelector('.swiper-button-prev');
    this.showHalfSlides = this.dataset.showHalfSlides;
  }

  connectedCallback() {
      this.initSwiper();
  }

  initSwiper() {
    if (this.swiperEl) {
      // @ts-ignore - Swiper is loaded globally via script tag
      const swiper = new (window.Swiper || Swiper)(this.swiperEl, {
        // Add your Swiper options here
        loop: false,
        slidesPerView: 1.5,
        spaceBetween: 20,
        freemode: true,
        scrollbar: {
            el: `.swiper-scrollbar`,
            draggable: true,
            hide: false,
        },
        navigation: {
            nextEl: this.nextArrow,
            prevEl: this.prevArrow,
            enabled: false,
        },
        breakpoints: {
            640: {
                slidesPerView: this.showHalfSlides == "true" ? 2.5 : 2,
            },
            1024: {
                slidesPerView: this.showHalfSlides == "true" ? 3.5 : 3,
                navigation: {
                    enabled: true,
                },
            },
        },
      });
    }
  }
}

customElements.define('content-carousel', ContentCarousel);
